export class DeviceInfo {
    private static _deviceProperties: DeviceProperties | null = null;

    public static get deviceProperties(): DeviceProperties {
        if (DeviceInfo._deviceProperties == null) {
            DeviceInfo._deviceProperties = DeviceInfo._getDeviceProperties();
            DeviceInfo._setDeviceClasses(DeviceInfo._deviceProperties, document.getElementsByTagName("html")[0]);
        }
        return DeviceInfo._deviceProperties;
    }

    public static getParameterByName(name: string): string {
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        const results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    private static _setDeviceClasses(deviceProperties: DeviceProperties, element: HTMLElement): void {
        if (deviceProperties.android)
            element.classList.add("android");
        if (deviceProperties.blackBerry)
            element.classList.add("blackBerry");
        if (deviceProperties.iOS)
            element.classList.add("ios");
        if (deviceProperties.wp)
            element.classList.add("wp");

        if (deviceProperties.phone)
            element.classList.add("phone");
        if (deviceProperties.tablet)
            element.classList.add("tablet");
        if (deviceProperties.desktop)
            element.classList.add("desktop");

        if (deviceProperties.touch)
            element.classList.add("touch");
        if (deviceProperties.highContrast)
            element.classList.add("high-contrast");
        if (deviceProperties.installedApp)
            element.classList.add("installed-app");

        element.classList.add(Browser[deviceProperties.browser]);
    }

    private static _getDeviceProperties(): DeviceProperties {
        const deviceProperties: DeviceProperties = { touch: false, wp: false, android: false, iOS: false, phone: false, tablet: false, desktop: false, blackBerry: false, highContrast: false, installedApp: false, browser: Browser.unknown };

        // Mozilla/5.0 (Windows NT 6.2; ARM; Trident/7.0; Touch; rv:11.0; WPDesktop; NOKIA; Lumia 520) like Gecko
        // Mozilla/5.0 (Windows Phone 8.1; ARM; Trident/7.0; Touch; rv:11.0; IEMobile/11.0; NOKIA; Lumia 520) like Gecko
        // Mozilla/5.0 (Windows NT 6.2; ARM; Trident/7.0; Touch; rv:11.0; WPDesktop; Microsoft; Virtual) like Gecko
        // Mozilla/5.0 (Windows Phone 8.1; ARM; Trident/7.0; Touch; rv:11.0; IEMobile/11.0; Microsoft; Virtual) like Gecko
        // Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0; ARM; Touch; WPDesktop)
        // Mozilla/5.0 (compatible; MSIE 10.0; Windows Phone 8.0; Trident/6.0; IEMobile/10.0; ARM; Touch; HTC; Windows Phone 8X by HTC)
        // Mozilla/5.0 (Mobile; Windows Phone 8.1; Android 4.0; ARM; Trident/7.0; Touch; rv:11.0; IEMobile/11.0; NOKIA; Lumia 520) like iPhone OS 7_0_3 Mac OS X AppleWebKit/537 (KHTML, like Gecko) Mobile Safari/537
        if (navigator.userAgent.match(/(?:Windows Phone)|(?:IEMobile)|(?:WPDesktop)/i) || DeviceInfo.getParameterByName("OS") === "WP") {
            deviceProperties.touch = true;
            deviceProperties.wp = true;
            deviceProperties.phone = true;
        } else {
            // Mozilla/5.0 (iPad; CPU OS 7_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Version/7.0 Mobile/11D167 Safari/9537.53
            if (navigator.userAgent.match(/iPad/i) || DeviceInfo.getParameterByName("OS") === "iOS" ||
            // od iPadOS 13 se uz neda rozlisit od stolni verze a je potreba pouzit tento zatim jediny funkcni workaround
             navigator.platform === "MacIntel" && navigator.maxTouchPoints > 0) {
                deviceProperties.touch = true;
                deviceProperties.iOS = true;
                deviceProperties.tablet = true;
            } else {
                // Mozilla/5.0 (iPhone; CPU iPhone OS 7_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Version/7.0 Mobile/11D167 Safari/9537.53
                if (navigator.userAgent.match(/iPhone/i)) {
                    deviceProperties.touch = true;
                    deviceProperties.iOS = true;
                    deviceProperties.phone = true;
                } else {
                    // Mozilla/5.0 (BB10; Kbd) AppleWebKit/537.35+ (KHTML, like Gecko) Version/10.2.1.2141 Mobile Safari/537.35+
                    if (navigator.userAgent.match(/BlackBerry|BB10/i) || DeviceInfo.getParameterByName("OS") === "BlackBerry") {
                        deviceProperties.touch = true;
                        deviceProperties.blackBerry = true;
                    } else {
                        // Mozilla/5.0 (Linux; U; Android 4.0.3; cs-cz; TA7300 Build/IML74K) AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Safari/534.30                               – GoGEN - Android Browser
                        // Mozilla/5.0 (Android; Mobile; rv:28.0) Gecko/28.0 Firefox/28.0                                                                                                   – Firefox 28 on Nexus 5
                        // Mozilla/5.0 (Linux; Android 4.4.2; Nexus 5 Build/KOT49H) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/32.0.1700.72 Mobile Safari/537.36 OPR/19.0.1340.69721     – Opera 19
                        // Mozilla/5.0 (Linux; Android 4.4.2; Nexus 5 Build/KOT49H) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/33.0.1750.136 Mobile Safari/537.36                        – Chrome 33
                        // Mozilla/5.0 (Linux; Android 4.4.2; Nexus 5 Build/KOT49H) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/30.0.0.0 Mobile Safari/537.36                 – Android Browser 4.4
                        // Mozilla/5.0 (Linux; Android 4.4.2; Nexus 7 Build/KOT49H) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/34.0.1847.114 Safari/537.36
                        // Mozilla/5.0 (Android; Tablet; rv:28.0) Gecko/28.0 Firefox/28.0                                                                                                   – Firefox 28 on Nexus 7
                        // Mozilla/5.0 (Linux; Android 4.4.2; Virtual Machine Build/KOT49H) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/30.0.0.0 Safari/537.36                – Android Browser 4.4
                        if (navigator.userAgent.match(/Android/i) || DeviceInfo.getParameterByName("OS") === "Android") {
                            deviceProperties.touch = true;
                            deviceProperties.android = true;
                        } else {
                            // Desktop
                            // Mozilla/5.0 (Windows NT 6.3; WOW64; Trident/7.0; Touch; rv:11.0) like Gecko
                            // Mozilla/5.0 (Windows NT 6.3; Win64; x64; Trident/7.0; Touch; rv:11.0) like Gecko
                            // Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0; Touch)
                            // Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)                         – 32 - bit Internet Explorer 10 on 32 - bit Windows 8
                            // Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; WOW64; Trident/6.0)                  – 32 - bit Internet Explorer 10 on 64 - bit Windows 8
                            // Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Win64; x64; Trident/6.0)             – 64 - bit Internet Explorer 10 on 64 - bit Windows 8
                            // Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; ARM; Trident/6.0; Touch)             – Internet Explorer 10 on Windows RT
                            // Mozilla/5.0 (Windows NT 6.3; WOW64; rv:27.0) Gecko/20100101 Firefox/27.0
                            // Mozilla/5.0 (Windows NT 6.3; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/32.0.1700.107 Safari/537.36 OPR/19.0.1326.63
                            // Mozilla/5.0 (Windows NT 6.3; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/33.0.1750.146 Safari/537.36
                            if (navigator.userAgent.match(/Trident.*Touch/i) /* && navigator.userAgent.match(/ARM|Win64/i) */) {
                                deviceProperties.touch = true;
                            } else {
                                // Mozilla/5.0 (Mobile; ZTEOPEN; rv:18.0) Gecko/18.0 Firefox/18.0                           – Firefox OS 1.1
                                if (navigator.userAgent.match(/Mobile/i)) {
                                    deviceProperties.touch = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        if (typeof window.matchMedia !== "undefined" && (window.matchMedia("screen and (max-device-width:480px) and (max-device-height:800px) and (orientation:portrait)").matches ||
            window.matchMedia("screen and (max-device-width:800px) and (max-device-height:480px) and (orientation:landscape)").matches ||
            DeviceInfo.getParameterByName("device") === "phone")) {
            deviceProperties.phone = true;
        }

        // standardni prohlizec Androidu 4.4 pri detekci na max-device-width poziva fyzicke rozmery zarizeni :-(
        if (deviceProperties.android && !deviceProperties.phone) {
            if (window.matchMedia("screen and (max-width:480px) and (max-height:800px) and (orientation:portrait)").matches ||
                window.matchMedia("screen and (max-width:800px) and (max-height:480px) and (orientation:landscape)").matches) {
                deviceProperties.phone = true;
            }
        }

        deviceProperties.touch = false;

        //jestli jsou vsechny dosavadni property false, nastavi se desktop
        if (DeviceInfo._checkIsDesktop(deviceProperties))
            deviceProperties.desktop = true;

        if (typeof window.matchMedia !== "undefined" && window.matchMedia("@media screen and (-ms-high-contrast: active)").matches) {
            deviceProperties.highContrast = true;
        }

        // zrusi zobrazeni prizpusobene pro dotykove obrazovky
        if (DeviceInfo.getParameterByName("touch") === "false") {
            deviceProperties.touch = false;
        }

        // na iOS jestli je aplikace nainstalovana na plochu
        if ((navigator as any).standalone === true)
            deviceProperties.installedApp = true;

        try {
            // presunuto ze souboru CheckCompatibilityAndLoadModules - prepracovat
            // -------------------------------------------------------------------
            if ((self as any).Reflect.ownKeys(self).filter((v: string) => typeof v === "string" && ((v as any).startsWith("ms") || (v as any).startsWith("MS"))).length > 0)
                if (navigator.userAgent.toLowerCase().indexOf("trident") > -1) // Kvůli LW
                    deviceProperties.browser = Browser.explorer;
                else
                    deviceProperties.browser = Browser.edgeHtml;
            else if (navigator.userAgent.indexOf("Edg") !== -1)
                deviceProperties.browser = Browser.edgeChromium;
            else if ((self as any).chrome)
                deviceProperties.browser = navigator.userAgent.match(/Opera|OPR\//) != null ? Browser.opera : Browser.chrome;
            else if ((self as any).Reflect.ownKeys(self).filter((v: string) => typeof v === "string" && (v as any).startsWith("moz")).length > 0)
                deviceProperties.browser = Browser.firefox;
            else if ((self as any).Reflect.ownKeys(self).filter((v: string) => typeof v === "string" && (v as any).startsWith("webkit")).length > 0)
                deviceProperties.browser = Browser.safari;
            else
                deviceProperties.browser = Browser.unknown;
        } catch (e) {
            // Prázdný catch
        }
        // -------------------------------------------------------------------

        //android nepodporuje navigator.standalone
        //navigator.standalone = navigator.standalone || (screen.height - document.documentElement.clientHeight < 40)

        return deviceProperties;
    }

    /**
     * Testuje vstupni objekt, jestli vsechny jeho property jsou FALSE
     * @param deviceProperties objekt s boolovskymi property, priklad { Touch: boolean; WP: boolean; Android: boolean; iOS: boolean; ... }
     */
    private static _checkIsDesktop(deviceProperties: DeviceProperties): boolean {
        return !(deviceProperties.wp || deviceProperties.android || deviceProperties.iOS ||
            deviceProperties.blackBerry || deviceProperties.phone || deviceProperties.tablet);
    }
}

export interface DeviceProperties {
    touch: boolean;
    wp: boolean;
    android: boolean;
    iOS: boolean;
    blackBerry: boolean;
    phone: boolean;
    tablet: boolean;
    desktop: boolean;
    highContrast: boolean;
    installedApp: boolean;
    browser: Browser;
}

export enum Browser {
    chrome,
    opera,
    firefox,
    edgeHtml,
    edgeChromium,
    safari,
    explorer,
    unknown,
}
